export default __webpack_public_path__ + "static/media/promos-icon.26b61204.webp";